if (typeof document === "undefined") return;
var createStylesheet = (chunkId, fullhref, oldTag, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	if (__webpack_require__.nc) {
		linkTag.nonce = __webpack_require__.nc;
	}
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && event.type;
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + errorType + ": " + realHref + ")");
			err.name = "ChunkLoadError";
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			if (linkTag.parentNode) linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;


	if (oldTag) {
		oldTag.parentNode.insertBefore(linkTag, oldTag.nextSibling);
	} else {
		document.head.appendChild(linkTag);
	}
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, null, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"src_pages_dashboard_Dashboard_tsx":1,"src_pages_ballots__ballotTableScreen_scss-src_shared-components_tableheader_TableHeader_scss":1,"src_pages_ballots_containers_BallotDetails_Container_tsx-src_shared-components_DescriptionBox-4d8672":1,"src_pages_WorkItemDetails_index_tsx":1,"src_pages_NegativeCommentsReview_NegativeCommentsReview_tsx-src_shared-components_tableheader-589e78":1,"src_pages_Ballot_Ballot_tsx":1,"src_pages_BallotDetailsAddItems_BallotDetailsAddItems_tsx-src_shared-components_DescriptionBo-0bb0c5":1,"src_pages_Ansi_ManageAnsi_index_tsx-src_shared-components_tableheader_TableHeader_scss":1,"src_pages_Ansi_BSR108_index_tsx-src_pages_Ansi_BSR108_index_scss-src_pages_Ansi_CommonCompone-6c33b2":1,"src_pages_Ansi_BSR109_index_tsx-src_pages_Ansi_BSR108_index_scss-src_shared-components_ErrorD-3b87ee":1,"src_pages_Ansi_AnsiAuditLog_index_tsx-src_shared-components_tableheader_TableHeader_scss":1,"src_pages_Ansi_PINSReports_index_tsx-src_pages_Ansi_CommonComponent_common-components_scss-sr-8864d7":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr

// no prefetching

// no preloaded